// components/IfPermission.js
import React from "react";
import { usePermissions } from "../../hooks/usePermissions";

export const IfPermission = ({
    permission,
    anyPermissions,
    allPermissions,
    fallback = null,
    inverse = false, // new prop
    children,
}) => {
    const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

    let access = true;

    if (permission) access = hasPermission(permission);
    else if (anyPermissions?.length) access = hasAnyPermission(...anyPermissions);
    else if (allPermissions?.length) access = hasAllPermissions(...allPermissions);

    // If inverse is true, flip the access
    if (inverse) access = !access;

    return access ? <>{children}</> : <>{fallback}</>;
};
